import { SectionCard } from '@atlas/ui-components'
import type { ReactNode } from 'react'

/** A grouped section card (Classification / Format / Context / …). */
export function FormCard({ title, children }: { title: string; children: ReactNode }) {
	return (
		<SectionCard title={title} className="p-6">
			<div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
		</SectionCard>
	)
}
